import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { CallidusCurrencyPipe } from '@shared/pipes/currency/callidus-currency.pipe';

@Component({
  selector: 'app-additional-coverage-box',
  imports: [
    NgClass,
    ReactiveFormsModule,
    FormsModule,
    TranslocoPipe
  ],
  providers: [CallidusCurrencyPipe],
  templateUrl: './additional-coverage-box.component.html',
  styleUrl: './additional-coverage-box.component.scss'
})
export class AdditionalCoverageBoxComponent<T> implements OnInit {

  @Input() title!: string;
  @Input() text!: string;
  @Input() icon!: string;
  @Input() ctrl!: FormControl<T | null>;
  @Input() id!: string;
  switchValues: [T, T] = [false as any, true as any];
  useCustomValues = false;
  switchValue = false;

  @Input() set customSwitchValues(customSwitchValues: [T, T]) {
    this.switchValues = customSwitchValues;
    this.useCustomValues = true;
  }

  setControlValue(): void {
    this.ctrl.setValue(this.switchValue ? this.switchValues[1] : this.switchValues[0]);
  }

  toggleSwitchValueFromContainer(): void {
    if (this.ctrl.disabled) return;
    this.switchValue = !this.switchValue;
    this.setControlValue();
  }

  ngOnInit(): void {
    if (this.ctrl.value === this.switchValues[1]) {
      this.switchValue = true;
    }
  }
}
